module.exports = __webpack_public_path__ + "img/sentra8.3198046c.jpeg";